import React, { useEffect, useRef, useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import Dashboardheader from "../components/dashboardheader/DashboardHeader";
import {
    Button,
    Select,
    Card,
    Alert,
    Row,
    Col,
    Typography,
    Tabs,
    Divider,
    Breadcrumb,
    Radio,
    Input,
    Modal,
    Table,
    Spin
} from "antd";
import {
    CameraOutlined,
    VideoCameraOutlined,
    LoginOutlined,
    LogoutOutlined,
} from "@ant-design/icons";


const { Option } = Select;
const { Text } = Typography;
const { TabPane } = Tabs;
const { TextArea } = Input;

/* ─────────────────────────────────────────
   Ant Design Spin Overlay Component
───────────────────────────────────────── */

const CircularLoader = ({ message = "Processing..." }) => (
    <div
        style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.45)",
            backdropFilter: "blur(3px)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
        }}
    >
        <Spin
            size="large"
            styles={{
                indicator: { color: "#ffffff" },
            }}
        >
            <div style={{ width: 80, height: 80 }} />
        </Spin>

        <p
            style={{
                marginTop: 12,
                color: "#ffffff",
                fontSize: 14,
                fontWeight: 500,
                letterSpacing: "0.5px",
                opacity: 0.9,
            }}
        >
            {message}
        </p>
    </div>
);

/* ─────────────────────────────────────────
   Loader message helper
───────────────────────────────────────── */
const getLoaderMessage = (loadingStage) => {
    switch (loadingStage) {
        case "location": return "Fetching Location Please Wait!";
        case "camera": return "Accessing camera...";
        case "submitting": return "Submitting attendance...";
        case "leads": return "Fetching customer leads...";
        default: return "Processing...";
    }
};

export default function OnDutyAttendance({ open, onClose }) {
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const streamRef = useRef(null);
    const navigate = useNavigate();

    const [photoColor, setPhotoColor] = useState(false)

    const [yesterdayMin, setYesterdayMin] = useState("");
    const [yesterdayMax, setYesterdayMax] = useState("");



    useEffect(() => {
        const now = new Date();

        // Get yesterday
        const yesterday = new Date(now);
        yesterday.setDate(now.getDate() - 1);
        const today = new Date(now);

        const year = yesterday.getFullYear();
        const month = String(yesterday.getMonth() + 1).padStart(2, "0");
        const day = String(yesterday.getDate()).padStart(2, "0");

        const tyear = today.getFullYear();
        const tmonth = String(today.getMonth() + 1).padStart(2, "0");
        const tday = String(today.getDate()).padStart(2, "0");

        setYesterdayMin(`${year}-${month}-${day}T00:00`);
        setYesterdayMax(`${tyear}-${tmonth}-${tday}T23:59`);
    }, []);


    const [locationCheck, setLocationCheck] = useState({ latitude: 0.0, longitude: 0.0 });
    const [workLocation, setWorkLocation] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingStage, setLoadingStage] = useState("");
    const [permissionDenied, setPermissionDenied] = useState(false);
    const [cameraReady, setCameraReady] = useState(false);
    // NEW: track whether a photo has been captured
    const [capturedPhoto, setCapturedPhoto] = useState(null);

    const { authData, backUrl, bssBackUrl, googlemapAPI } = useContext(AuthContext);

    const [showTodayModal, setShowTodayModal] = useState(false);
    const [isOnduty, setIsOnduty] = useState("");
    const [onDutyStatus, setIsOndutyStatus] = useState("");
    const [checkInData, setCheckInData] = useState(null);
    const [checkOutData, setCheckOutData] = useState(null);
    const [masterData, setMasterData] = useState(null);
    const [checkIn, setCheckIn] = useState({ check_in_location: "On-Duty", check_in_photo: null });
    const [salesManagers, setSalesManagers] = useState([]);
    const [selectedLead, setSelectedLead] = useState(null);
    const [isLive, setIsLive] = useState(false);
    const [isPast, setIsPast] = useState(false);
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);

    const isSalesUser = !!authData?.employee?.sales_id;

    useEffect(() => {
        if (!isSalesUser) {
            setIsOnduty("general");
        }
    }, [isSalesUser]);

    /* ── Fetch today's attendance ── */
    const fetchData = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/hr/attendance/onduty/today/`, {
                headers: { Authorization: `Bearer ${authData.access}` },
            });
            setMasterData(res.data);
            setCheckInData({
                check_in_time: res.data.first_check_in,
                status: res.data.status,
                photo: res.data.first_check_in_photo,
                location: res.data.check_in_location,
                latitude: res.data.check_in_latitude,
                longitude: res.data.check_in_longitude,
            });
            setCheckOutData({
                check_out_time: res.data.last_check_out,
                photo: res.data.last_check_out_photo,
                location: res.data.check_out_location,
                latitude: res.data.check_out_latitude,
                longitude: res.data.check_out_longitude,
            });
        } catch (error) {
            console.error("Error fetching attendance data:", error);
        }
    };

    /* ── Fetch work locations ── */
    const fetchWorkLocation = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/worklocation/`);
            setWorkLocation(res.data.results);
        } catch (err) {
            console.error("Error fetching work locations", err);
        }
    };

    /* ── Fetch sales managers if customer visit ── */
    useEffect(() => {
        if (isOnduty === "Customer Visit") {
            const fetchSalesManagers = async () => {
                try {
                    setLoadingStage("leads");
                    setLoading(true);
                    const res = await axios.get(
                        `${bssBackUrl}/leads/customer_leads/${authData?.employee?.sales_id}/`,
                        { headers: { Authorization: `Bearer ${authData.access}` } }
                    );
                    setSalesManagers(res.data.results || res.data);
                } catch (err) {
                    console.error("Error fetching sales managers:", err);
                    toast.error("Failed to fetch sales managers");
                } finally {
                    setLoading(false);
                    setLoadingStage("");
                }
            };
            fetchSalesManagers();
        }
    }, [isOnduty]);

    useEffect(() => {
        fetchData();
    }, [])

    useEffect(() => {
        fetchWorkLocation();
    }, []);

    /* ── Camera logic ── */
    const startCamera = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: "user" },
                audio: false,
            });
            if (videoRef.current) {
                videoRef.current.srcObject = stream;
                streamRef.current = stream;
                await videoRef.current.play();
                setCameraReady(true);
            }
        } catch (err) {
            console.error("Camera error:", err);
            toast.error("Camera access denied or not available.");
        }
    };

    useEffect(() => {
        startCamera();
        return () => {
            if (streamRef.current) {
                streamRef.current.getTracks().forEach((track) => track.stop());
                streamRef.current = null;
                setCameraReady(false);
            }
        };
    }, []);

    /* ── Geolocation ── */
    const getLocation = async (options = {}) => {
        return new Promise((resolve, reject) => {
            if (!navigator.geolocation) return reject(new Error("Geolocation not supported"));

            const defaultOptions = { enableHighAccuracy: true, timeout: 10000, maximumAge: 10000 };

            const watchId = navigator.geolocation.watchPosition(
                async (pos) => {
                    const { latitude, longitude, accuracy } = pos.coords;
                    setLocationCheck({ latitude, longitude });
                    if (accuracy <= 10) {
                        navigator.geolocation.clearWatch(watchId);
                        resolve({ lat: latitude, lng: longitude, accuracy, name: await getAreaName(latitude, longitude) });
                    }
                },
                (err) => { navigator.geolocation.clearWatch(watchId); reject(err); },
                { ...defaultOptions, ...options }
            );

            setTimeout(() => {
                navigator.geolocation.clearWatch(watchId);
                navigator.geolocation.getCurrentPosition(
                    async (pos) => {
                        const { latitude, longitude, accuracy } = pos.coords;
                        setLocationCheck({ latitude, longitude });
                        resolve({ lat: latitude, lng: longitude, accuracy, name: await getAreaName(latitude, longitude) });
                    },
                    reject,
                    defaultOptions
                );
            }, 35000);
        });
    };

    const getAreaName = async (lat, lng) => {
        try {
            const response = await fetch(
                `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
            );
            const data = await response.json();
            if (!data.address) return null;
            // const { suburb, neighbourhood, village, town, city, county } = data.address;
            console.log("Data :", data)
            return data.display_name;
        } catch (error) {
            console.error("Error fetching area name:", error);
            return null;
        }
    };

    /* ── UPDATED: Capture Photo button handler ── */
    const handleCapturePhoto = () => {
        if (!cameraReady) {
            toast.error("Camera not ready. Please wait for camera to load.");
            return;
        }
        if (videoRef.current && canvasRef.current) {
            const ctx = canvasRef.current.getContext("2d");
            ctx.drawImage(videoRef.current, 0, 0, 320, 240);
            const dataUrl = canvasRef.current.toDataURL("image/png");
            setCapturedPhoto(dataUrl);
            toast.success("Photo captured");
        }
    };

    const base64ToFile = (base64String, fileName) => {
        const arr = base64String.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) u8arr[n] = bstr.charCodeAt(n);
        return new File([u8arr], fileName, { type: mime });
    };

    const getDistanceInMeters = (lat2, lon2, lat1, lon1) => {
        const R = 6371e3;
        const toRad = (deg) => (deg * Math.PI) / 180;
        const φ1 = toRad(lat1), φ2 = toRad(lat2);
        const Δφ = toRad(lat2 - lat1), Δλ = toRad(lon2 - lon1);
        const a =
            Math.sin(Δφ / 2) ** 2 +
            Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) ** 2;
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    };

    /* ── Attendance submit ── */
    const handleAttendance = async (type) => {
        // ===============================
        // STEP 1: VALIDATIONS
        // ===============================

        if (!cameraReady) {
            toast.error("Camera not ready. Please wait for camera to load.");
            return;
        }

        if (!capturedPhoto) {
            toast.error("Please capture a photo before submitting attendance.");
            return;
        }

        const loc = workLocation.find(
            (item) => item.name === checkIn.check_in_location
        );

        if (!loc) {
            toast.error("Work location not found");
            return;
        }

        if (
            checkIn.check_in_location?.toLowerCase().trim() === "on-duty" &&
            !isOnduty
        ) {
            toast.error("Please select an On-Duty type (General/Customer Visit)");
            return;
        }

        if (isOnduty && !isLive && !isPast) {
            toast.error("Please select Live or Past mode for OnDuty attendance.");
            return;
        }

        if (isPast && (!startTime || !endTime)) {
            toast.error("Please enter both start time and end time for past attendance.");
            return;
        }

        if (isOnduty === "Customer Visit" && (!selectedLead || !selectedLead.lead_no)) {
            toast.error("Please search and select a customer lead");
            return;
        }

        try {
            setLoadingStage("location");
            setLoading(true);

            // ===============================
            // STEP 2: GET LOCATION
            // ===============================

            let coords = {};

            try {
                coords = await getLocation();
            } catch (err) {
                console.warn("Geolocation failed. Continuing without coordinates.");
                coords = {};
            }

            const userLat = parseFloat(coords?.lat || 0);
            const userLng = parseFloat(coords?.lng || 0);
            const userLocationName = coords?.name || "";

            const workLat = parseFloat(loc.latitude);
            const workLng = parseFloat(loc.longitude);
            const radius = parseFloat(loc.radius);

            if (userLat && userLng) {
                const distance = getDistanceInMeters(
                    workLat,
                    workLng,
                    userLat,
                    userLng
                );

                if (distance > radius) {
                    toast.error(
                        `You are ${Math.round(distance)} meters away. Must be within ${radius}m.`
                    );
                    setLoading(false);
                    setLoadingStage("");
                    return;
                }
            }

            setLoadingStage("submitting");

            // ===============================
            // STEP 3: PREPARE FORM DATA
            // ===============================
            const formData = new FormData();
            const file = base64ToFile(capturedPhoto, "attendance.png");

            if (type === "Check-In") {

                formData.append("check_in_location", userLocationName);
                formData.append("check_in_work_site", checkIn.check_in_location || "");
                formData.append("check_in_photo", file);
                formData.append("check_in_latitude", userLat);
                formData.append("check_in_longitude", userLng);


                formData.append("check_in_mode", isLive ? "LIVE" : "PAST");


                if (isPast) {
                    formData.append("start_time", startTime);
                    formData.append("end_time", endTime);
                }

                if (isOnduty) {
                    formData.append("onduty_type_check_in", isOnduty);
                    formData.append("check_in_remarks", onDutyStatus || "");
                }

                if (isOnduty === "Customer Visit" && selectedLead) {
                    formData.append("lead_data", JSON.stringify(selectedLead));
                }

                // 🔎 Debug FormData properly
                for (let pair of formData.entries()) {
                    console.log(pair[0], pair[1]);
                }

                const res = await axios.post(
                    `${backUrl}/api/hr/attendance/check-in/`,
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${authData.access}`,
                        },
                    }
                );

                console.log("Lead Data : ", formData.lead_data)

                toast.success(res.data?.message || "Check-In successful");

                setCheckInData({
                    ...res.data,
                    photo: capturedPhoto,
                    location: userLocationName,
                });

            } else {
                // ===============================
                // CHECK OUT
                // ===============================

                formData.append("check_out_location", userLocationName);
                formData.append("check_out_work_site", checkIn.check_in_location || "");
                formData.append("check_out_photo", file);
                formData.append("check_out_latitude", userLat);
                formData.append("check_out_longitude", userLng);


                formData.append("check_out_mode", isLive ? "LIVE" : "PAST");


                if (isPast) {
                    formData.append("start_time", startTime);
                    formData.append("end_time", endTime);
                }

                if (isOnduty) {
                    formData.append("onduty_type_check_out", isOnduty);
                    formData.append("check_out_remarks", onDutyStatus || "");
                }

                if (isOnduty === "Customer Visit" && selectedLead) {
                    formData.append("lead_data", JSON.stringify(selectedLead));
                }

                // 🔎 Debug FormData properly
                for (let pair of formData.entries()) {
                    console.log(pair[0], pair[1]);
                }

                const res = await axios.post(
                    `${backUrl}/api/hr/attendance/check-out/`,
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${authData.access}`,
                        },
                    }
                );

                console.log("Lead Data : ", formData.lead_data)

                toast.success(res.data?.message || "Check-Out successful");

                setCheckOutData({
                    ...res.data,
                    photo: capturedPhoto,
                    location: userLocationName,
                });
            }
        } catch (err) {
            console.error("Error submitting attendance:", err);

            const data = err.response?.data;

            const backendMessage =
                data?.non_field_errors?.[0] ||
                data?.detail ||
                data?.error ||
                data?.message ||
                err.message ||
                "Failed to submit attendance.";

            toast.error(backendMessage);
        } finally {
            setLoading(false);
            setLoadingStage("");
        }
    };

    const activeStyle = { backgroundColor: "#0e497b", color: "white", borderColor: "#0e497b" };

    /* ────────────────────────────────────────── */
    return (
        <>
            {/* ── Circular loader overlay ── */}
            {loading && <CircularLoader message={getLoaderMessage(loadingStage)} />}

            <ToastContainer />

            <Row gutter={[16, 16]} style={{ padding: "20px" }} justify={checkInData || checkOutData ? "start" : "center"}>
                <Col xs={24} sm={24} md={12} lg={12}>
                    <Card bordered style={{ borderRadius: 12, boxShadow: "0 4px 12px rgba(0,0,0,0.05)" }}>

                        {/* ── UPDATED: Capture Photo button ── */}
                        {/* <div style={{ textAlign: "center", marginBottom: "16px" }}>
                            <Button
                                type="primary"
                                onClick={handleCapturePhoto}
                                disabled={!cameraReady}
                                style={{ backgroundColor: "#0e497b", color: "white", borderRadius: 6, width: "100%", maxWidth: 300 }}
                                icon={<CameraOutlined />}
                            >
                                Capture Photo
                            </Button>
                        </div> */}

                        {permissionDenied && (
                            <Alert type="warning" showIcon message="Camera permission required" style={{ marginBottom: 16 }} />
                        )}

                        {/* ── Video preview (hidden after capture, or always shown for re-capture) ── */}
                        <div style={{ position: "relative", textAlign: "center", marginBottom: 16 }}>
                            {/* Live video — hidden once photo is captured */}
                            <video
                                ref={videoRef}
                                autoPlay
                                muted
                                playsInline
                                width="100%"
                                height="auto"
                                style={{
                                    borderRadius: 12,
                                    border: cameraReady ? "1px solid #0e497b" : "1px solid #ccc",
                                    backgroundColor: "#f0f0f0",
                                    maxWidth: "300px",
                                    display: capturedPhoto ? "none" : "block",
                                    margin: "0 auto",
                                }}
                            />

                            {/* Camera Off placeholder — shown when camera not ready and no photo captured */}
                            {!cameraReady && !capturedPhoto && (
                                <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", textAlign: "center" }}>
                                    <CameraOutlined style={{ fontSize: 48, color: "#999" }} />
                                    <p style={{ color: "#999", marginTop: 8 }}>Camera Off</p>
                                </div>
                            )}

                            {/* ── UPDATED: Canvas — visible and shows captured photo ── */}
                            <canvas
                                ref={canvasRef}
                                width="320"
                                height="240"
                                style={{
                                    display: capturedPhoto ? "block" : "none",
                                    margin: "0 auto",
                                    borderRadius: 12,
                                    border: "2px solid #0e497b",
                                    maxWidth: "300px",
                                    width: "100%",
                                }}
                            />

                            {/* Retake button shown after capture */}
                            {/* {capturedPhoto && (
                <div style={{ marginTop: 8 }}>
                  <Button
                    size="small"
                    onClick={() => setCapturedPhoto(null)}
                    style={{ color: "#0e497b", borderColor: "#0e497b" }}
                    icon={<VideoCameraOutlined />}
                  >
                    Retake
                  </Button>
                </div>
              )} */}
                        </div>

                        {/* Work Location */}
                        <div style={{ textAlign: "center", marginBottom: 16 }}>
                            <Text strong style={{ display: "block", marginBottom: 8 }}>Attendance Type</Text>
                            <input
                                type="text"
                                name="check_in_location"
                                value={checkIn.check_in_location}
                                onChange={(e) =>
                                    setCheckIn({ ...checkIn, check_in_location: e.target.value })
                                }
                                style={{
                                    width: "90%",
                                    maxWidth: 300,
                                    textAlign: "center"
                                }}
                                readOnly
                            />
                            {/* <Select
                                showSearch
                                allowClear
                                value={checkIn.check_in_location}
                                onChange={(value) =>
                                    setCheckIn({ ...checkIn, check_in_location: value })
                                }
                                placeholder="Select place of work"
                                style={{ width: "90%", maxWidth: 300 }}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option?.children
                                        ?.toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                            >

                                <Option key="onduty" value="On-Duty">
                                    On-Duty
                                </Option>
                            </Select> */}

                            {checkIn.check_in_location?.toLowerCase().trim() !== "on-duty" ? (
                                <Text type="danger" style={{ display: "block", marginTop: 8 }}>
                                    {(() => {
                                        const loc = workLocation.find(
                                            (item) => item.name?.toLowerCase().trim() === checkIn.check_in_location?.toLowerCase().trim()
                                        );
                                        const radius = loc?.radius || 0;
                                        if (checkIn.check_in_location === "") return null;
                                        return `You must be within ${radius} meters of this location`;
                                    })()}
                                </Text>
                            ) : (
                                <>
                                    {/* Onduty type */}

                                </>
                            )}
                        </div>
                        <>
                            <div className="mt-3">
                                <Radio.Group
                                    onChange={(e) => setIsOnduty(e.target.value)}
                                    value={isOnduty}
                                    optionType="button"
                                    buttonStyle="solid"
                                    style={{
                                        border: "none",
                                        display: "flex",
                                        flexWrap: "wrap",
                                        justifyContent: "center",
                                        gap: "8px",
                                        marginTop: "10px",
                                    }}
                                >
                                    {(isSalesUser ? ["general", "Customer Visit"] : ["general"]).map((type) => (
                                        <Radio.Button
                                            key={type}
                                            value={type}
                                            style={{
                                                backgroundColor: isOnduty === type ? "#0e497b" : "#fff",
                                                color: isOnduty === type ? "#fff" : "#000",
                                                borderColor: "#0e497b",
                                            }}
                                        >
                                            {type === "general"
                                                ? "General"
                                                : type === "special"
                                                    ? "Special"
                                                    : "Customer Visit"}
                                        </Radio.Button>
                                    ))}
                                </Radio.Group>
                            </div>
                            <br />

                            {/* Live / Past toggle */}
                            <section className="d-flex justify-content-center">
                                <Button onClick={() => { setIsLive(true); setIsPast(false); }} style={isLive ? activeStyle : {}}>Live</Button>
                                <Button onClick={() => { setIsLive(false); setIsPast(true); }} className="ms-3" style={isPast ? activeStyle : {}}>Past</Button>
                            </section>

                            {isPast && (
                                <section className="d-flex justify-content-center gap-3 mt-3">
                                    <div>
                                        <label className="form-label">Start Time</label>
                                        <input
                                            type="datetime-local"
                                            className="form-control"
                                            value={startTime || ""}
                                            min={yesterdayMin}
                                            max={yesterdayMax}
                                            onChange={(e) => setStartTime(e.target.value)}
                                        />
                                    </div>

                                    <div>
                                        <label className="form-label">End Time</label>
                                        <input
                                            type="datetime-local"
                                            className="form-control"
                                            value={endTime || ""}
                                            min={yesterdayMin}
                                            max={yesterdayMax}
                                            onChange={(e) => setEndTime(e.target.value)}
                                        />
                                    </div>
                                </section>
                            )}

                            {/* Customer Lead search */}
                            {isOnduty === "Customer Visit" && salesManagers?.length > 0 && (
                                <>
                                    <div style={{ textAlign: "center", marginTop: 12 }}>
                                        <Input
                                            placeholder="Enter Lead No, or Phone"
                                            style={{ maxWidth: "200px" }}
                                            value={selectedLead?.searchText || ""}
                                            onChange={(e) => {
                                                const val = e.target.value.toLowerCase();
                                                const filtered = salesManagers.find(
                                                    (sm) =>
                                                        sm.lead_no?.toString().toLowerCase().includes(val) ||
                                                        sm.number?.toString().toLowerCase().includes(val)
                                                );
                                                setSelectedLead(filtered ? { ...filtered, searchText: e.target.value } : { searchText: e.target.value });
                                            }}
                                        />
                                    </div>

                                    {selectedLead && selectedLead.lead_no && (
                                        <div style={{ marginTop: 16 }}>
                                            <Table
                                                size="small"
                                                pagination={false}
                                                bordered
                                                components={{
                                                    header: {
                                                        cell: (props) => (
                                                            <th {...props} style={{ backgroundColor: "#0e497b", color: "white", marginTop: "20px" }}>
                                                                {props.children}
                                                            </th>
                                                        ),
                                                    },
                                                }}
                                                scroll={{ x: 1200 }}
                                                columns={[
                                                    { title: "Lead No", dataIndex: "lead_no", key: "lead_no" },
                                                    { title: "Project", dataIndex: ["project", "title"], key: "title" },
                                                    { title: "Customer Name", dataIndex: "name", key: "name" },
                                                    {
                                                        title: "Phone", key: "number",
                                                        render: (record) => {
                                                            const primary = record.number || "No primary phone number";
                                                            const secondary = record.secondary_number || "9876543210";
                                                            return secondary ? `${primary} / ${secondary}` : primary;
                                                        },
                                                    },
                                                    {
                                                        title: "Email", key: "email",
                                                        render: (record) => {
                                                            const primary = record.email || "No primary email ID";
                                                            const secondary = record.secondary_email || "samplemailid@gmail.com";
                                                            return secondary ? `${primary} / ${secondary}` : primary;
                                                        },
                                                    },
                                                    { title: "Status", dataIndex: ["status", "title"], key: "status" },
                                                    {
                                                        title: "Assigned On", dataIndex: "assigned_on", key: "assigned_on",
                                                        render: (date) => (date ? dayjs(date).format("DD/MM/YYYY") : "-"),
                                                    },
                                                ]}
                                                dataSource={[selectedLead]}
                                                rowKey="lead_no"
                                            />
                                        </div>
                                    )}
                                </>
                            )}
                            <center>
                                <TextArea
                                    value={onDutyStatus}
                                    onChange={(e) => setIsOndutyStatus(e.target.value)}
                                    placeholder="Enter status"
                                    rows={4}
                                    style={{ width: "90%", maxWidth: 300, marginTop: 12 }}
                                />
                            </center>

                        </>

                        <Divider />

                        <div style={{ textAlign: "center", marginTop: "16px", marginBottom: "16px" }}>
                            <Button
                                type="primary"
                                onClick={() => {
                                    setPhotoColor(true)
                                    handleCapturePhoto()
                                }}
                                disabled={!cameraReady}
                                style={{ backgroundColor: photoColor ? "green" : "red", color: photoColor ? "white" : "white", borderRadius: 6, width: "100%", maxWidth: 300, border: photoColor ? "1px solid black" : "none" }}
                                icon={<CameraOutlined />}
                            >
                                Capture Photo
                            </Button>
                        </div>


                        {/* Check-In / Check-Out buttons */}
                        <div style={{ textAlign: "center", display: "flex", flexDirection: "column", gap: 10, alignItems: "center" }}>
                            <Button
                                type="primary"
                                loading={loading && loadingStage === "submitting"}
                                disabled={!cameraReady || !capturedPhoto || loading}
                                onClick={() => handleAttendance("Check-In")}
                                style={{ backgroundColor: "#0e497b", color: "white", borderRadius: 6, width: "90%", maxWidth: 300 }}
                                icon={<LoginOutlined />}
                            >
                                Check-In
                            </Button>

                            {!isPast && (
                                <Button
                                    danger
                                    loading={loading && loadingStage === "submitting"}
                                    disabled={!cameraReady || !capturedPhoto || loading}
                                    onClick={() => handleAttendance("Check-Out")}
                                    icon={<LogoutOutlined />}
                                    style={{ borderRadius: 6, width: "90%", maxWidth: 300 }}
                                >
                                    Check-Out
                                </Button>
                            )}
                        </div>
                    </Card>
                </Col>

                {/* Attendance log modal */}
                {/* <Modal
                    title="Attendance Log"
                    open={showTodayModal}
                    onCancel={() => setShowTodayModal(false)}
                    width={"90%"}
                    footer={[<Button key="close" onClick={() => setShowTodayModal(false)}>Close</Button>]}
                >
                    <TodaysLog />
                </Modal> */}

                {(checkInData || checkOutData) && (
                    <Col xs={24} sm={24} md={12} lg={12}>
                        <Card bordered style={{ borderRadius: 12, boxShadow: "0 4px 12px rgba(0,0,0,0.05)" }}>
                            <Tabs defaultActiveKey="1">
                                {checkInData && (
                                    <TabPane tab="Check-In" key="1">
                                        <center>
                                            <img
                                                src={checkInData.photo}
                                                alt="Check-In"
                                                style={{ width: "100%", maxWidth: 320, borderRadius: 12, marginTop: 8, border: "1px solid #d9d9d9" }}
                                            />
                                            <div style={{ marginTop: 16, color: "#555" }}>
                                                <p><b>Time:</b> {dayjs(checkInData.check_in_time).format("DD/MM/YYYY HH:mm:ss")}</p>
                                                {/* {!checkOutData && (
                                                    <p>
                                                        <b>Status:</b>{" "}
                                                        <span style={{
                                                            color:
                                                                checkInData?.status === "Present" ? "green" :
                                                                    checkInData?.status === "Absent" ? "red" :
                                                                        checkInData?.status === "Late" ? "orange" : "gray",
                                                        }}>
                                                            {checkInData?.status }
                                                        </span>
                                                    </p>
                                                )} */}
                                                {checkInData?.latitude && checkInData?.longitude && (
                                                    <p>
                                                        <b>Address:</b>{" "}
                                                        <a
                                                            href={`https://www.google.com/maps/search/?api=1&query=${checkInData.latitude},${checkInData.longitude}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ color: "#1677ff", textDecoration: "underline", cursor: "pointer" }}
                                                        >
                                                            {checkInData.location || "View on Google Maps"}
                                                        </a>
                                                    </p>
                                                )}
                                            </div>
                                        </center>
                                    </TabPane>
                                )}

                                {checkOutData && (
                                    <TabPane tab="Check-Out" key="2">
                                        {checkOutData.photo !== null ? (
                                            <center>
                                                <img
                                                    src={checkOutData.photo}
                                                    alt="Check-Out"
                                                    style={{ width: "100%", maxWidth: 320, borderRadius: 12, marginTop: 8, border: "1px solid #d9d9d9" }}
                                                />
                                                <div style={{ marginTop: 16, color: "#555" }}>
                                                    <p><b>Time:</b> {dayjs(checkOutData.check_out_time).format("DD/MM/YYYY HH:mm:ss")}</p>
                                                    <p>
                                                        <b>Address:</b>{" "}
                                                        <a
                                                            href={`https://www.google.com/maps/search/?api=1&query=${checkOutData.latitude},${checkOutData.longitude}`}
                                                            rel="noopener noreferrer"
                                                            style={{ color: "#1677ff", textDecoration: "underline", cursor: "pointer" }}
                                                        >
                                                            {checkOutData.location}
                                                        </a>
                                                    </p>
                                                </div>
                                            </center>
                                        ) : (
                                            <center>No Checkout Data</center>
                                        )}
                                    </TabPane>
                                )}
                            </Tabs>
                        </Card>
                    </Col>
                )}
            </Row>
        </>
    );
}







